const reCaptchaKeys: { [key: string]: string } = {
  'chat.avalai.ir': '6LfYCY8nAAAAAKmmJb1-dVH9QhO90s6gm8NUwK66',
  'chat.avalai.org': '6LcJjbooAAAAABUYp3nTNdx-65CKCTvyDqTIiPsS',
  'chat.avalgpt.com': '6LcJjbooAAAAABUYp3nTNdx-65CKCTvyDqTIiPsS'
};
const defaultReCaptchaV3Key = '6LfYCY8nAAAAAKmmJb1-dVH9QhO90s6gm8NUwK66';
const reCaptchaV3Key = reCaptchaKeys[window.location.hostname] || defaultReCaptchaV3Key;

// Base API URLs for different environments
const apiUrls = {
  production: 'https://chat.avalai.org',
  local: 'https://localhost'
};

// const isViteEnvironment = typeof import.meta !== 'undefined';
// eslint-disable-next-line import/no-mutable-exports
let API_BASE_URL = apiUrls.local;

if (import.meta.env.VITE_BACKEND_ENV === 'local') {
  API_BASE_URL = apiUrls.local;
} else if (window.location.hostname in reCaptchaKeys) {
  API_BASE_URL = `https://${window.location.hostname}`;
}

export { API_BASE_URL, reCaptchaV3Key };
